<template>
    <v-carousel
        class="wrapper"
        width="100vw"
        :height="bannerHeight"
        hide-delimiter-background
        delimiter-icon="mdi-minus"
        next-icon="$vuetify.icons.kknext"
        prev-icon="$vuetify.icons.kkprev"
        cycle
        :reverse="continuous"
        interval="4000"
        :show-arrows="isShowNavigation"
        :hide-delimiters="!isShowNavigation"
    >
        <v-carousel-item v-for="(banner, i) in $store.state.banners" :key="i">
            <a
                target="_blank"
                :href="banner.link"
                :data-ga="`Hero Banner|${banner.link}`"
                ><v-img
                    class="banner-image"
                    :src="`${baseURL}${banner[responsiveBannerImage]}`"
                >
                </v-img>
            </a>
        </v-carousel-item>
    </v-carousel>
</template>

<script>
import { getUmbracoEnv } from '@/config/umbraco-env';

export default {
    name: 'banner-carousel',
    data() {
        return {
            continuous: false,
            baseURL: getUmbracoEnv(),
        };
    },
    computed: {
        responsiveBannerImage() {
            if (this.$vuetify.breakpoint.width <= 768) {
                return 'imageSmall';
            } else if (this.$vuetify.breakpoint.width <= 1080) {
                return 'imageMedium';
            } else {
                return 'imageUrl';
            }
        },
        bannerHeight() {
            if (this.$vuetify.breakpoint.width <= 768) {
                return 670;
            } else if (this.$vuetify.breakpoint.width <= 1080) {
                return 550;
            } else {
                return 740;
            }
        },
        isShowNavigation() {
            return this.$store.state.banners.length > 1;
        },
    },
};
</script>
<style lang="scss" scoped>
.wrapper {
    .banner-image {
        height: 100%;
        width: 100%;
    }
}
</style>
<style lang="scss">
.v-carousel.wrapper {
    .v-carousel__controls__item.v-btn--round {
        margin-left: 20px !important;
        margin-right: 20px !important;
        span.v-btn__content i.v-icon {
            font-size: 0 !important;
        }
    }
    .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
        opacity: 1;
        height: 4px;
        width: 60px;
        left: -16px;
        top: 12px;
    }
    .v-btn--round {
        border-radius: 0;
        background: transparent;
    }
    .v-btn {
        &:hover:before,
        &:focus:before {
            color: transparent;
            transition: none;
        }
        &:before {
            transition: none;
        }
        &.v-btn--active {
            &:before {
                color: white;
            }
        }
    }
    .v-btn--icon.v-size--small {
        .v-icon {
            height: 4px;
            width: 60px;
            opacity: 0.5;
            background-color: lightgray;
        }
    }
    .v-btn--active {
        .v-icon {
            background-color: darkgray !important;
        }
    }
    .v-ripple__container {
        display: none;
    }
    .v-window__prev,
    .v-window__next {
        &:hover {
            background: white;
            opacity: 0.8;
        }
        background-color: rgba(255, 255, 255);
        opacity: 0.3;
        height: 80px;
        width: 46px;
        margin: 0;
    }
    .v-window__prev {
        border-top-right-radius: 6px;
        border-top-left-radius: 0;
        border-bottom-right-radius: 6px;
        border-bottom-left-radius: 0;
        &:hover {
            #kk-prev-arrow {
                fill: #2960e8;
            }
        }
        .v-btn__content {
            height: 80px;
            width: 46px;
            margin: auto; // center arrow for Firefox and Edge
        }
        .v-btn--icon.v-size--default .v-icon {
            height: 33px;
            width: 14px;
            margin-left: 8px;
        }
    }
    .v-window__next {
        border-top-right-radius: 0;
        border-top-left-radius: 6px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 6px;
        &:hover {
            #kk-next-arrow {
                fill: #2960e8;
            }
        }
        .v-btn__content {
            height: 80px;
            width: 46px;
            margin: auto; // center arrow for Firefox and Edge
        }
        .v-btn--icon.v-size--default .v-icon {
            height: 33px;
            width: 14px;
            margin-left: 12px;
        }
    }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* IE10+ specific styles go here */
    .v-carousel.wrapper {
        .v-window__prev .v-btn__content {
            width: 0;
            top: 50%;
            margin-top: 8px;
        }
        .v-window__next .v-btn__content {
            width: 0;
            top: 50%;
            margin-top: 8px;
        }
    }
    .v-carousel__controls__item .v-btn__content {
        left: -38px;
        margin-bottom: 1px;
    }
}
</style>
